const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/Forms/utils.ts';
import { MetaKatItem } from '../../defs/kisim';

export const filterInactiveAndIncompleteMetaKatItems = (metaKatItems: MetaKatItem[]) => {
    const deactivatedElements: string[] = [];

    return metaKatItems.reduce((accumulator: MetaKatItem[], metaKatItem) => {
        const { FKEY, ICODE, KAT, LEVEL, PCODE, STATUS } = metaKatItem;
        // exclude first entry
        if (LEVEL === '1') return accumulator;

        // if inactive, or parent is inactive, consider item inactive
        if (STATUS === 'I' || deactivatedElements.includes(PCODE)) {
            deactivatedElements.push(ICODE);
            return accumulator;
        }

        if (FKEY || KAT) {
            accumulator.push(metaKatItem);
        }

        return accumulator;
    }, []);
};
